import { z } from 'zod';
import { moneySchema, percentSchema, idSchema, isoDateSchema, isoDateTimeSchema, currencyCodeSchema, } from './common.js';
import { compareDecimal, roundDecimal } from '../utils/decimal.js';
import { fiscalFxProofSchema } from './fiscal-fx.js';
export const vendorFiscalFxReviewSchema = z
    .object({
    taxCurrency: z.enum(['DOCUMENT', 'EUR']),
    sourceHash: z.string().regex(/^[a-f0-9]{64}$/u),
    evidenceText: z.string().trim().min(20).max(10000),
    euroTaxBuckets: z
        .array(z
        .object({
        taxRate: percentSchema,
        statedTaxAmount: moneySchema,
        legalTaxAmount: moneySchema,
    })
        .strict())
        .max(200)
        .default([]),
})
    .strict()
    .superRefine((value, context) => {
    const issue = (path, message) => context.addIssue({ code: 'custom', path, message });
    if (value.taxCurrency === 'DOCUMENT' && value.euroTaxBuckets.length)
        issue(['euroTaxBuckets'], 'fiscalFx.vendorOriginalCurrency');
    if (value.taxCurrency === 'EUR' && !value.euroTaxBuckets.length)
        issue(['euroTaxBuckets'], 'fiscalFx.vendorEuroEvidence');
    const seen = new Set();
    value.euroTaxBuckets.forEach((row, index) => {
        if (seen.has(roundDecimal(row.taxRate, 6)))
            issue(['euroTaxBuckets', index, 'taxRate'], 'fiscalFx.vendorDuplicateRate');
        seen.add(roundDecimal(row.taxRate, 6));
        if (compareDecimal(row.statedTaxAmount, '0') < 0 ||
            compareDecimal(row.legalTaxAmount, '0') < 0 ||
            compareDecimal(row.legalTaxAmount, row.statedTaxAmount) > 0)
            issue(['euroTaxBuckets', index, 'legalTaxAmount'], 'fiscalFx.vendorLegalAmount');
    });
});
export const vendorFiscalFxProofSchema = z
    .object({
    review: vendorFiscalFxReviewSchema,
    sourceMaterial: z.string().min(2).max(2000000),
    revision: z.number().int().positive(),
    sourceCurrency: currencyCodeSchema,
    rateTaxDate: isoDateSchema,
    reportingTaxDate: isoDateSchema,
    fiscalFx: fiscalFxProofSchema.nullable(),
    reviewedById: idSchema,
    reviewedAt: isoDateTimeSchema,
    rows: z
        .array(z
        .object({
        position: z.number().int().positive(),
        taxRate: percentSchema,
        originalTax: moneySchema,
        statedTax: moneySchema,
        legalTax: moneySchema,
        deductibleTax: moneySchema,
        bookDeductibleTax: moneySchema,
        fiscalDifference: moneySchema,
    })
        .strict())
        .min(1)
        .max(200),
})
    .strict();
export const vendorFiscalFxContextSchema = z.object({
    required: z.boolean(),
    sourceHash: z.string().regex(/^[a-f0-9]{64}$/u),
    review: vendorFiscalFxReviewSchema.nullable(),
    proof: vendorFiscalFxProofSchema.nullable(),
});
//# sourceMappingURL=fiscal-fx-vendor.js.map